var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Servicer page")]),_c('p',[_vm._v(_vm._s(_vm.msg))]),_c('button',{staticClass:"button sign-out",on:{"click":_vm.signout}},[_vm._v("Sign out")])])])}
var staticRenderFns = []

export { render, staticRenderFns }